import { Injectable } from '@angular/core';
import { Crew } from '../interfaces/crew';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrewCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/crews/' ;
  }

  // Create Crew
  add(record: Crew) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Crew Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Crews List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Crew Object
  update(record: Crew) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Crew>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Crew Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}